import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromUser from '../reducers/user';

export const getUserStore = createFeatureSelector<fromUser.UserState>('user');
export const getUser = createSelector(
  getUserStore,
  fromUser.getUser
);
export const isUserLoading = createSelector(
  getUserStore,
  fromUser.isUserLoading
);
export const isUserLoaded = createSelector(
  getUserStore,
  fromUser.isUserLoaded
);
export const getUserRole = createSelector(
  getUserStore,
  fromUser.getUserRole
);
export const getUserCountry = createSelector(
  getUserStore,
  fromUser.getUserCountry
);
export const getGeoLocation = createSelector(
  getUserStore,
  fromUser.getGeoLocation
);
